import React from 'react'
import { Provider } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import { withStyles } from '@mui/styles'

import store from 'redux/store'
import { Toast } from './toast'
import { SnackbarUtilsConfigurator } from './toastConfig'

const customStyles = {
  containerAnchorOriginBottomCenter: {
    width: 500,
    maxWidth: 'calc(100% - 40px)',
    overflow: 'visible',
    '& > div': {
      position: 'absolute',
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
}

function ToastList(props) {
  const { classes } = props
  return (
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={100}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transitionDuration={{
          enter: 1000,
          exit: 1000,
        }}
        classes={{
          containerAnchorOriginBottomCenter: classes.containerAnchorOriginBottomCenter,
        }}
      >
        <SnackbarUtilsConfigurator />
        <Toast />
      </SnackbarProvider>
    </Provider>
  )
}

export default withStyles(customStyles)(ToastList)
